import { render, staticRenderFns } from "./TermsHistoryPrint.vue?vue&type=template&id=2be350fd&scoped=true&"
import script from "./TermsHistoryPrint.vue?vue&type=script&lang=js&"
export * from "./TermsHistoryPrint.vue?vue&type=script&lang=js&"
import style0 from "./TermsHistoryPrint.vue?vue&type=style&index=0&id=2be350fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be350fd",
  null
  
)

export default component.exports